import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productImageBadgesStyles } from "@insite/content-library/Components/ProductImageBadges";
import { textBadgeStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsTextBadge";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

textBadgeStyles.container = {
    css: css`
        display: flex;
        column-gap: 8px;
        flex-wrap: wrap;
    `,
};
textBadgeStyles.badge = {
    css: css`
        margin-top: 0px;
    `,
};
textBadgeStyles.badgeText = {
    css: css`
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.bold};
        font-size: ${TYPOGRAPHY.size.smallest};
        line-height: ${TYPOGRAPHY.lineHeight.base};
        width: 100%;
        white-space: nowrap;
        ${wrapInContainerStyles}
    `,
};
productImageBadgesStyles.imageItem={
    css: css`
        padding: 5px;
        justify-content: flex-start;
    `,
};
